module.exports = __webpack_public_path__ + "img/sequence-suidobashi.4de943d0.jpg";